import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CategoryManagement from "./CategoryManagement";
import userMangeOperations from '../../../../../../redux/UserManagement/operations'
import userManageSelectors from '../../../../../../redux/UserManagement/selectors'
import { SetAddCategory, setCategoryById, setCheckCategory, setDeleteCategory } from "redux/UserManagement/action";
import { popupInitialData } from "utils";
import { commonPopupDisplay } from "client/Components/Administraton/utils/AdministrationUtils";
import ConfirmationBee from '../../../../../assets/images/ConfirmationBee.svg';
import SuccessBee from '../../../../../assets/images/SuccessBee.svg';

const CategoryManagementContainer = () => {
  const dispatch = useDispatch();
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState(0);
  const [selectedName, setSelectedName] = useState("")
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const dispatchCheckCategoryDuplication = userMangeOperations.dispatchGetCheckCategory(dispatch);
  const dispatchGetAddCategory = userMangeOperations.dispatchGetAddCategory(dispatch);
  const dispatchGetCategoryList = userMangeOperations.dispatchGetCategoryList(dispatch);
  const dispatchDeleteCategory = userMangeOperations.dispatchDeleteCategory(dispatch);
  const dispatchGetCategoryById = userMangeOperations.dispatchGetCategoryById(dispatch)
  const initialValues = {
    id: 0,
    categoryName: '',
    isActive: false
  }
  const [form, setForm] = useState<any>(initialValues)
  const [formError, setFormError] = useState<any>()
  const [categoryDetail, setCategoryDetail] = useState<any>([])
  const [isSubmit, setIsSubmit] = useState(false)
  const [isAdding, setIsAdding] = useState(false)
  const {
    checkCategory,
    categoryById,
    addCategoryVal,
    isCheck,
    deleteCategory,
    isCategoryCheck
  }: any
    = useSelector(
      (state: any) => ({
        checkCategory: userManageSelectors.checkCategory(state),
        categoryById: state.UserManagement.categoryById,
        addCategoryVal: state.UserManagement.addCategory,
        isCheck: state.UserManagement.isCheck,
        deleteCategory: userManageSelectors.deleteCategory(state),
        isCategoryCheck: userManageSelectors.isCategoryCheck(state),
      })
    )
  const handleChange = (evt: any, item: any) => {
    let { name, value } = evt.target;
    value = item
    name = evt.target.getAttribute('name') || evt.currentTarget.getAttribute("name")
    setForm({ ...form, [name]: value });
    if (name == "categoryName") {
      let error = ""
      if (value === undefined || value === "" || value === null) {
        error = "Please enter Category";
      }
      setFormError(error)
    }
  }

  const handleClickSave = () => {
    let error = ""
    let valid = true
    if (form.categoryName === undefined || form.categoryName === "" || form.categoryName === null) {
      error = "Please enter Category";
      valid = false
      setIsSubmit(false)
    } else {
      setIsSubmit(true)
    }
    setFormError(error)
    if (valid == true) {
      let filledVal = {

        id: categoryById?.hasOwnProperty("id") ? categoryById.id : 0,
        categoryName: form?.categoryName,
        isActive: form?.isActive
      }
      setCategoryDetail(filledVal)
    }
  }
  useEffect(() => {
    if (isSubmit && categoryDetail?.categoryName) {
      dispatchCheckCategoryDuplication(categoryDetail)
    }
  }, [categoryDetail, isSubmit])
  useEffect(() => {
    if (!checkCategory && categoryDetail?.categoryName) {
      dispatchGetAddCategory(categoryDetail)
      setCategoryDetail([])
      setIsAdding(true)
    }
    else if (checkCategory && isSubmit) {
      let message = "Category Name given is already exist."
      commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      setIsSubmit(false)
    }
  }, [checkCategory, isCheck])
  useEffect(() => {
    if (addCategoryVal != undefined && addCategoryVal != 0 && isSubmit) {
      if (addCategoryVal > 0 && !checkCategory) {
        var message: any = "";
        if((categoryById.hasOwnProperty("id") && categoryById.id != 0)){
          message = "Category has been updated successfully";
        }else{
          message = `Category has been created successfully with id ` + addCategoryVal;
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, SuccessBee, "SUCCESS", handleCreateModal)
      } else if ((checkCategory && addCategoryVal == 0 && isCategoryCheck) || (addCategoryVal == "error")) {
        var message: any = "";
        if(addCategoryVal == "error"){
          message = "Error Occured while processing the request."
        }else{
          message = "Category Name given is already exist."
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      }
      setIsSubmit(false)
      setIsAdding(false)
    }
  }, [addCategoryVal, isAdding])

  const handleFailurePopup = () => {
    hideSuccessDialog()
    dispatch(SetAddCategory(0))
  }

  const hideSuccessDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false });
  };
  useEffect(() => {
    if (categoryById?.hasOwnProperty("id") && categoryById.id > 0) {
      setShowCreateModal(true)
      setForm({
        ...form, categoryName: categoryById?.categoryName,
        isActive: categoryById?.isActive
      })
    }
  }, [categoryById?.id])
  useEffect(() => {
    dispatchGetCategoryList()
  }, [])
  const optionHandler = (evt: any, option: any, props: any) => {
    if (option.value === "edit") {
      setShowCreateModal(true);
      handleCreateModal()
      dispatchGetCategoryById(props.id)
    }
    if (option.value === "delete") {
      setShowDeleteModal(true);
      setSelectedId(props?.id)
      setSelectedName(props?.categoryName)
    }
  };

  const handleDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleCreateModal = () => {
    setShowCreateModal((prev) => !prev);
    dispatch(setCheckCategory(true))
    hideSuccessDialog()
    if (showCreateModal == true) {
      setForm(initialValues);
      setFormError("")
      dispatchGetCategoryList()
      dispatch(setCategoryById(initialValues))
      dispatch(setCategoryById([]))
    }
    dispatch(SetAddCategory(0))
  }

  const handleDeleteClick = () => {
    dispatchDeleteCategory(selectedId)
    setSelectedId(0)
  }
  useEffect(() => {
    if (deleteCategory) {
      setShowDeleteModal(false);
      setShowInfoModal(true)
      dispatch(setDeleteCategory(false))
    }
  }, [deleteCategory])
  const handleInfoModal = () => {
    setShowInfoModal(false);
    setSelectedName("")
    dispatchGetCategoryList()
  }
  return (
    <CategoryManagement
      handleChange={handleChange}
      handleClickSave={handleClickSave}
      form={form}
      formError={formError}
      initialValues={initialValues}
      setForm={setForm}
      setFormError={setFormError}
      hideSuccessDialog={hideSuccessDialog}
      optionHandler={optionHandler}
      handleCreateModal={handleCreateModal}
      showCreateModal={showCreateModal}
      showDeleteModal={showDeleteModal}
      handleDeleteModal={handleDeleteModal}
      handleDeleteClick={handleDeleteClick}
      selectedName={selectedName}
      showInfoModal={showInfoModal}
      handleInfoModal={handleInfoModal}
      Popupcontent = {Popupcontent}
    />
  )
}

export default CategoryManagementContainer;